import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { RiskRecordState } from '@reducers/risk-record';

export const getRiskRecord = (state: RootState): RiskRecordState => state.riskRecord;
export const getRiskRecordData = createSelector(getRiskRecord, (record) => record?.data);
export const isRiskRecordLoading = createSelector(getRiskRecord, (record) => record?.loading);
